import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation, useParams} from "react-router-dom";
import {routeFunctions, routes} from "../../../../../core/models/static/routes/app-routes";
import CustomerPaymentMethodsView from "../../customer/general-information/payment-methods";
import useAccessLevels from "../../../../hooks/use-access-levels";
import CustomerProfileView from "./profile";
import CustomerPromotionsView from "./promotions";
import CustomerLoginLogsView from "../login-logs";
import CustomerAddressesV2View from "./addresses-v2";

const CustomerGeneralInformationViews = () => {
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Checks the pathname of the url with each change of the url.
     * if the pathname was [customer.base] or [customer.generalInformation.base] then redirects the customer to the profile view.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {
            path: [routes.customer.base, routes.customer.generalInformation.base],
            exact: true
        })) {
            if (operatorAccessLevels.packages.base.customerDetails) {
                history.replace(routeFunctions.customer.generalInformation.profile(params.customerId));
            } else if (operatorAccessLevels.packages.sales.promotions) {
                history.replace(routeFunctions.customer.generalInformation.promotions(params.customerId));
            } else if (operatorAccessLevels.packages.sales.manageCustomerAddresses) {
                history.replace(routeFunctions.customer.generalInformation.addresses(params.customerId));
            } else if (operatorAccessLevels.packages.sales.manageCustomerPaymentMethods || operatorAccessLevels.packages.sales.customerGiftCards) {
                history.replace(routeFunctions.customer.generalInformation.paymentMethods(params.customerId));
            } else if (operatorAccessLevels.packages.base.customerLoginLogs) {
                history.replace(routeFunctions.customer.generalInformation.loginLogs(params.customerId));
            } else {
                history.replace(routeFunctions.customer.generalInformation.redirect(params.customerId).concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.base.customerDetails, operatorAccessLevels.packages.base.customerLoginLogs, operatorAccessLevels.packages.sales.customerGiftCards, operatorAccessLevels.packages.sales.manageCustomerAddresses, operatorAccessLevels.packages.sales.manageCustomerPaymentMethods, operatorAccessLevels.packages.sales.promotions, params.customerId])

    return (
        <>
            <Switch>
                <Route path={routes.customer.base} exact/>
                <Route path={routes.customer.generalInformation.base} exact/>
                {
                    operatorAccessLevels.packages.base.customerDetails &&
                    <Route path={routes.customer.generalInformation.profile} exact>
                        <CustomerProfileView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.manageCustomerAddresses &&
                    <Route path={routes.customer.generalInformation.addresses} exact>
                        <CustomerAddressesV2View/>
                    </Route>
                }
                {
                    (
                        operatorAccessLevels.packages.sales.manageCustomerPaymentMethods ||
                        operatorAccessLevels.packages.sales.customerGiftCards
                    ) &&
                    <Route path={routes.customer.generalInformation.paymentMethods} exact>
                        <CustomerPaymentMethodsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.base.customerLoginLogs &&
                    <Route path={routes.customer.generalInformation.loginLogs} exact>
                        <CustomerLoginLogsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.customerPromotions &&
                    <Route path={routes.customer.generalInformation.promotions} exact>
                        <CustomerPromotionsView/>
                    </Route>
                }
                <Redirect to={routes.customer.generalInformation.base.concat(routes.error.accessDeniedForSection)}/>
            </Switch>
        </>
    );
};

export default CustomerGeneralInformationViews;
